import React from "react";
import icons from "../../../../../assets/images/icons";
import styles from "./SettingsList.module.scss";

/**
 * 설정 메뉴 리스트 (Figma 40005721:229820)
 * item: { id, icon, label, onClick, type?: 'button'|'toggle', value?: boolean, onToggle?, children? }
 */
function SettingsList({ className = "", items = [] }) {
  const iconMap = {
    personIcon: icons.messager?.personIcon,
    bell: icons.messager?.bell,
    bellOff: icons.messager?.bellOff,
    block: icons.messager?.block,
    alarm: icons.messager?.alarm,
    dnd: icons.messager?.dnd,
  };

  return (
    <div className={`${styles.root} ${className}`.trim()}>
      {items.map((item, i) => (
        <React.Fragment key={item.id ?? i}>
          {item.type === "divider" ? (
            <div className={styles.item}>
              <div style={{ padding: "0 16px" }}>
                <div className={styles.dividerLine} />
              </div>
            </div>
          ) : (
            <div className={styles.item}>
              <div className={styles.itemInner}>
                <div className={styles.row} onClick={item.type !== "toggle" ? item.onClick : undefined}>
                  <div className={styles.iconWrap} aria-hidden>
                    {iconMap[item.icon] && (
                      <img src={iconMap[item.icon]} alt="" className={styles.iconImg} />
                    )}
                  </div>
                  <span className={styles.label}>{item.label}</span>
                  {item.type === "toggle" && (
                    <button
                      type="button"
                      className={`${styles.toggle} ${item.value ? styles.toggleOn : ""}`}
                      onClick={() => item.onToggle?.(!item.value)}
                      aria-label={item.label}
                    >
                      <div className={styles.toggleThumb} />
                    </button>
                  )}
                </div>
              </div>
              {item.children}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default SettingsList;
